import { AutogenLayoutDriverPayRateGroupList } from "./autogen/AutogenLayoutDriverPayRateGroupList";
import {
    ClickEvent, CrudDecorator, CrudDecoratorCloseEvent, DataSourceExecutionEvent, DataSourceMode, Layout,
    TableContentsChangedEvent, TableRow
} from "@mcleod/components";
import { UrlUtil } from "@mcleod/core";
import { DriverPayRateGroup } from "./DriverPayRateGroup";

export class DriverPayRateGroupList extends AutogenLayoutDriverPayRateGroupList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "id", sort: "asc" },
            { field: "drs_payrate_header.customer_id", sort: "asc" },
            { field: "drs_payrate_header.effective_dt", sort: "asc" },
            { field: "drs_payrate_header.rate_method", sort: "asc" }
        ];
        this.tableDriverPayRateGroup.addContentsChangedListener((event: TableContentsChangedEvent) => {
            this.sourceDrsPayrateGroupList.search(this.sourceDrsPayrateGroupList.lastSearch);
        });
    }

    rateRowOnDblClick(event: ClickEvent) {
        const tableRow = event.target as TableRow;
        const layout = Layout.getLayout(this.tableDriverPayRateGroup.detailLayout) as DriverPayRateGroup;
        const key = tableRow.data.get("id");
        const urlParam = { mode: "update", key: key };
        const url = "/" + this.tableDriverPayRateGroup.detailLayout + UrlUtil.buildQueryString(urlParam);
        const crudPanel = new CrudDecorator({
            layout: layout,
            mode: DataSourceMode.UPDATE,
            dataSource: layout.mainDataSource,
            key: key,
            pseudoNavigateUrl: url,
            layoutLoadListeners: () => {
                layout.sourceDrsPayrateHeader.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
                    layout.selectRateRecordById(tableRow.data.get("drs_payrate_header.primary_key"));
                });
            },
            headerProps: {
                showClose: true,
                showSaveAndClose: true,
                showDelete: true,
                doAfterClose: (event: CrudDecoratorCloseEvent) => {
                    if (event.userDeleted()) {
                        this.sourceDrsPayrateGroupList.search(this.sourceDrsPayrateGroupList.lastSearch);
                    }
                },
                onExecute: () => {
                    this.sourceDrsPayrateGroupList.search(this.sourceDrsPayrateGroupList.lastSearch);
                }
            }
        });
        crudPanel.slideIn({ speed: 200 });
    }
}
